export const PAGE_ROUTE_HEADER = 'x-page-route';
